
export default {
  description: 'В онлайн аптеке Фармация можно заказать лекарства с доставкой. Мы предлагаем широкий ассортимент лекарственных и гомеопатических средств, косметики, витаминов, БАДов, ортопедических изделий, медицинской техники. Цены ниже, чем в розничных аптеках.',
  keywords: 'интернет-магазин, льгота, доставка, скидка, государственная гарантия',
  title: 'Интернет-аптека Фармация. Купить лекарства в Красноярске, цены',
  imgTitle: '',
  imgAlt: ''
}
